import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../button'
import Card from './index'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'

const Blog = ({ title, textContent, date, sales, read, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.blog]: true
  })

  return (
    <div {...attrs}>

      <Card.Body>
        <div
          className={'flex  flex-row justify-between mb-4 items-center'}
        >
          <Typography
            className={' text-green-500 '}
          >
            {sales}
          </Typography>
          <Typography
            size={'two'}
            className={' text-gray-400'}>
            {date}
          </Typography>
        </div>
        <div>
          <Typography
            className={'text-$black max-w-big mb-2'}
          >
            {title}
          </Typography>
          <Typography
            size={'two'}
            className={' mb-6 font-normal text-gray-400 '}
          >
            {read}
          </Typography>

        </div>
        <Button
          className={'w-16'}
          arrow
          href="https://www.google.com"
          iconRight
          target="_blank"
        >
          Leer mas
        </Button>

      </Card.Body>
    </div>
  )
}

Blog.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sales: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  read: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])

}

export default Blog
